export const HttpStatusCode = {
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  INTERNAL_SERVER: 500,
  SUCCESS: 200,
  TIME_OUT: 504,
};
